"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetYourPassword = exports.ResetYourPasswordArgs = void 0;
var get_component_1 = require("../../shared/helpers/get-component");
var reset_your_password_form_1 = require("./reset-your-password.form");
exports.ResetYourPasswordArgs = {
    onSubmit: function (formValues) {
        // Default - Just log the values to the console
        console.debug(formValues);
    },
};
exports.ResetYourPassword = (0, get_component_1.getComponent)(reset_your_password_form_1.ResetYourPasswordForm, exports.ResetYourPasswordArgs);
